import { Action } from '@ngrx/store';
import { ServiceGroup } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len

export const ADD_PENDING_DECLINED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Add Pending Declined Service In State';
export class AddPendingDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = ADD_PENDING_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { serviceGroup: ServiceGroup }) {}
}

export const REMOVE_PENDING_DECLINED_SERVICE_IN_STATE =
  '[VEHICLE_MAINTENANCE] Remove Pending Declined Service In State';
export class RemovePendingDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = REMOVE_PENDING_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: string }) {}
}

export const CLEAR_PENDING_DECLINED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Pending Declined Service In State';
export class ClearPendingDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_PENDING_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type PendingDeclinedServiceAction =
  | AddPendingDeclinedServiceInState
  | RemovePendingDeclinedServiceInState
  | ClearPendingDeclinedServiceInState;
